import React from 'react'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import Bugsnag from '@bugsnag/js'
import { getFormattedPrice } from 'util/numbers'
import { capitalize, pluralize } from 'util/strings'
import { INBOX, KB } from 'ducks/billing/productTypes'
import { styles } from './styles'

const PRODUCT_TO_PRODUCT_NAME = {
  [KB]: 'Knowledge base',
  [INBOX]: app.t('Mailbox'),
}

const PlanRow = ({
  name,
  product,
  cyclePrice,
  itemPrice,
  users,
  className,
  isNew,
  isUpgradingToAnnual,
  pricingModel,
  planCycle,
  isCycleChange,
}) => {
  if (!itemPrice && itemPrice !== 0) {
    Bugsnag.notify(new Error(`Plan item price shouldn't be null or undefined`))
    return null
  }
  const formattedItemPrice = getFormattedPrice(itemPrice, 'USD')
  const formattedItemPriceForAnnualUpgrade =
    isUpgradingToAnnual && isNew
      ? getFormattedPrice(itemPrice / 12, 'USD')
      : formattedItemPrice
  const formattedCyclePrice = getFormattedPrice(cyclePrice, 'USD')
  const formattedCyclePriceForOneYear = isNew
    ? getFormattedPrice(cyclePrice, 'USD')
    : getFormattedPrice(cyclePrice * 12, 'USD')
  const priceUnit = pricingModel === 'usage' ? 'each' : ''

  return (
    <div className={className}>
      <div css={[styles.row, text.styles.fontMedium]} className="grui mb-2">
        <div className="grui truncate">
          {isNew ? 'New' : 'Current'} {PRODUCT_TO_PRODUCT_NAME[product]}: {name}{' '}
          {isCycleChange && capitalize(planCycle)}
        </div>
        <div>
          {isUpgradingToAnnual
            ? formattedItemPriceForAnnualUpgrade
            : formattedCyclePrice}{' '}
          {isUpgradingToAnnual && product === INBOX
            ? `per ${app.t('agent')}`
            : ''}
        </div>
      </div>
      <div css={[styles.row, text.styles.text2Xs, styles.lightGrey]}>
        <div className="grui truncate">
          {product === INBOX && (
            <>
              {users} {pluralize(users, app.t('Agent'))}{' '}
              {isUpgradingToAnnual ? `billed annually` : ''}
            </>
          )}
        </div>
        <div>
          {isUpgradingToAnnual
            ? formattedCyclePriceForOneYear
            : formattedItemPrice}{' '}
          {isUpgradingToAnnual ? 'per year' : priceUnit}
        </div>
      </div>
    </div>
  )
}

export default PlanRow
